"use client"

import { useState } from "react"
import { Button } from "../../ui/Button"
import type { Offer } from "@local/offer/src/types"
import { getT } from "@local/i18n/src/t"
import { getLanguageForMarket } from "@local/i18n/src/languages"
import { reviews as reviewsCatalog } from "@local/i18n/src/catalogs/reviews"
import { SingleReview } from "./SingleReview"

export interface LoadMoreReviewsProps {
  reviews: NonNullable<Offer.FullWidthReviews["reviews"]>
  market?: string
}

export const LoadMoreReviews = ({ reviews, market }: LoadMoreReviewsProps) => {
  const [amountToDisplay, setAmount] = useState(4)
  const t = getT(getLanguageForMarket(market), { reviews: reviewsCatalog })

  const currentReviews = reviews?.slice(0, amountToDisplay)

  return (
    <>
      <ul className="invisible mx-10 hidden grid-cols-1 gap-6 overflow-hidden sm:visible sm:grid sm:grid-cols-2 md:grid-cols-4">
        {currentReviews?.map((review, index) => (
          <li
            key={`single-review-${review.id ?? index}`}
            className="flex list-none"
          >
            <SingleReview review={review} market={market} className="flex-1" />
          </li>
        ))}
      </ul>

      {amountToDisplay < reviews?.length && (
        <div className="invisible hidden flex-col items-center justify-center gap-4 md:visible md:flex md:flex-row">
          <Button
            type="button"
            className="mb-2 md:mb-0"
            onClick={() => {
              setAmount((a) => a + 4)
            }}
          >
            {t("reviews.loadMoreReviews")}
          </Button>
        </div>
      )}
    </>
  )
}
